import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";
import { Checkbox, InputNumber, Switch } from 'antd';
import { BsInfoCircleFill } from "react-icons/bs";
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from "./styles.module.css";

const formatCurrency = (value) =>
    `$${Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

function BidDataUpdateHubSpot({selectedDeal, getDealBids, selectedBids}) {

    const [salesTaxPercent, setSalesTaxPercent] = useState(0)
    const [includeSalesTax, setIncludeSalesTax] = useState(false)
    const salesTaxToUpdate = includeSalesTax ? salesTaxPercent : 0
    const [cumulativeMargin, setCumulativeMarign] = useState(0)
    const [cumulativeAmount, setCumulativeAmount] = useState(0)
    const [updateZeroValuesToHubspot, setUpdateZeroValuesToHubspot] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    const addAmount = (value)=>{
        setCumulativeAmount(prev => prev + value)
    }
    const subtractAmount = (value) => {
        setCumulativeAmount(prev => prev - value)
    }

    const addMargin = (value) =>{
        setCumulativeMarign(prev => prev + value)
    }

    const subtractMargin = (value) => {
        setCumulativeMarign(prev => prev - value)
    }

    useEffect(()=>{
        let bidData = getDealBids(selectedDeal._id)
    }, [selectedDeal])

    useEffect(()=>{
        setSalesTaxPercent(selectedBids[0]?.salesTaxPercent || 0)
    }, [selectedBids])

    const udpateDataToHubspot = async()=>{
        try{
            setIsUpdating(true)
            let response = await BreathAPIs.updateCostToHubspot({
                cumulativeMargin: cumulativeMargin,
                cumulativeAmount: cumulativeAmount,
                salesTaxPercent: salesTaxToUpdate,
                updateZeroValuesToHubspot: updateZeroValuesToHubspot,
                dealId: selectedDeal.HubSpotDealId
            })
            toast.success(response?.data?.message)
        }catch(err){
            console.log('err in updating data: ', err.message)
            toast.error(err?.response?.data?.message)
        }finally{
            setIsUpdating(false)
        }
    }

  return (
    <div className={styles['hubspot-update']}>
        <ToastContainer />
        <div className={styles['hubspot-update-header']}>
            <span className={styles['hubspot-update-heading']}>Update HubSpot</span>
            <span className={styles['hubspot-update-deal']}>{selectedDeal.dealname}</span>
        </div>
        <p className={styles['hubspot-update-subheading']}>Select the items that need to be updated in HubSpot.</p>

        <div className={styles['hubspot-update-panel']}>
            {selectedBids.length === 0 ?
                <div className={styles['hubspot-update-empty']}>No bids found for this deal.</div> :
                selectedBids.map((bid) => (
                    <div className={styles['hubspot-update-row']} key={bid._id ?? bid.bidNumber}>
                        <span className={styles['hubspot-update-bid']}>{bid.bidNumber}</span>
                        <div className={styles['hubspot-update-options']}>
                            <Checkbox onChange={(e)=>{e.target.checked ? addAmount(bid.totalCost + (bid.rebateAmount || 0)) : subtractAmount(bid.totalCost + (bid.rebateAmount || 0))}}>
                                Revenue <strong>{formatCurrency(bid.totalCost + (bid.rebateAmount || 0))}</strong>
                            </Checkbox>
                            <Checkbox onChange={(e)=>{e.target.checked ? addMargin(bid.totalMargin) : subtractMargin(bid.totalMargin)}}>
                                Margin <strong>{formatCurrency(bid.totalMargin)}</strong>
                            </Checkbox>
                        </div>
                    </div>
                ))
            }

            {selectedBids.length > 0 &&
                <div className={styles['hubspot-update-row']}>
                    <span className={styles['hubspot-update-bid']}>Sales Tax</span>
                    <div className={styles['hubspot-update-options']}>
                        <Checkbox checked={includeSalesTax} onChange={(e)=>{setIncludeSalesTax(e.target.checked)}}>
                            Sales Tax
                        </Checkbox>
                        <InputNumber
                            min={0}
                            max={100}
                            value={salesTaxPercent}
                            onChange={(value)=>{setSalesTaxPercent(value || 0)}}
                            addonAfter="%"
                            disabled={!includeSalesTax}
                        />
                    </div>
                </div>
            }

            <div className={`${styles['hubspot-update-row']} ${styles['big']}`}>
                <div className={styles['hubspot-update-total']}>
                    <span>Total Revenue</span>
                    <strong>{formatCurrency(cumulativeAmount)}</strong>
                </div>
                <div className={styles['hubspot-update-total']}>
                    <span>Total Margin</span>
                    <strong>{formatCurrency(cumulativeMargin)}</strong>
                </div>
                <div className={styles['hubspot-update-total']}>
                    <span>Sales Tax</span>
                    <strong>{salesTaxToUpdate}%</strong>
                </div>
            </div>
        </div>

        <div className={styles['hubspot-update-info']}>
            <BsInfoCircleFill />
            <span>By default, zero values won't be updated in HubSpot. Enable this to send zero values as well.</span>
            <Switch checked={updateZeroValuesToHubspot} onChange={(checked) => {setUpdateZeroValuesToHubspot(checked)}} />
        </div>

        <div className={styles['hubspot-update-actions']}>
            <button
                type="button"
                className={styles['view-bid-btn']}
                disabled={isUpdating}
                onClick={()=> {udpateDataToHubspot()}}
            >
                {isUpdating ? 'Updating...' : 'Update HubSpot'}
            </button>
        </div>
    </div>
  )
}

export default BidDataUpdateHubSpot
